module.exports = __webpack_public_path__ + "img/pin-empty@3x.59f20483.png";